import React, { useState } from "react";
import { checkLoggedIn } from "../../utils";
import DeleteIcon from "../../icons/DeleteIcon";
import { MoonLoader } from "react-spinners";

const CartProductRow = ({ cartItem, getUserCartData, ...props }) => {
  const [loading, setLoading] = useState(false);

  const handleIncrementQuantity = async () => {
    if (checkLoggedIn()) {
      setLoading(true);
      await props?.incrementQuantity(cartItem.id);
      getUserCartData();
      setLoading(false);
    } else {
      setLoading(true);
      setTimeout(() => {
        props?.incrementQuantity(cartItem.id);
        getUserCartData();
        setLoading(false);
      }, 1000);
    }
  };

  const handleDecrementQuantity = async () => {
    if (checkLoggedIn()) {
      setLoading(true);
      if (cartItem.qty === 1) {
        await props?.removeFromCart(cartItem.id);
        getUserCartData();
      } else {
        await props?.decrementQuantity(cartItem.id);
        getUserCartData();
      }
      setLoading(false);
    } else {
      setLoading(true);
      if (cartItem.qty === 1) {
        setTimeout(() => {
          props?.removeFromCart(cartItem.id);
          getUserCartData();
          setLoading(false);
        }, 1000);
      } else {
        setTimeout(() => {
          props?.decrementQuantity(cartItem.id);
          getUserCartData();
          setLoading(false);
        }, 1000);
      }
    }
  };

  const handleRemove = async (e) => {
    e.preventDefault();
    setLoading(true);
    await props?.removeFromCart(cartItem.id);
    setLoading(false);
  };

  const currencySymbols = {
    EUR: "€",
    USD: "$",
    AED: "AED",
  };
  const currencyCode = localStorage.getItem("currency") || "AED";
  const currencyPrefix = currencySymbols[currencyCode] ? currencySymbols[currencyCode] + " " : "AED ";

  const lineTotal = cartItem.itemTotal != null ? cartItem.itemTotal : (cartItem.qty * cartItem.price).toFixed(2);

  return (
    <div className="gpcart-row">
      <div className="gpcart-row-thumb">
        <img src={cartItem?.proimg?.[0]?.src} alt={cartItem?.title} />
      </div>

      <div className="gpcart-row-meta">
        <h4 className="gpcart-row-title">{cartItem.title}</h4>
        <div className="gpcart-row-price-mobile">
          {currencyPrefix}{cartItem.price}
        </div>
      </div>

      <div className="gpcart-row-price">
        <span className="gpcart-row-label">Price</span>
        <span className="gpcart-row-val">{currencyPrefix}{cartItem.price}</span>
      </div>

      <div className="gpcart-row-qty">
        <span className="gpcart-row-label">Qty</span>
        <div className="gpcart-stepper">
          <button
            type="button"
            className="gpcart-step-btn"
            onClick={handleDecrementQuantity}
            disabled={loading}
            aria-label={cartItem.qty === 1 ? "Remove" : "Decrease"}
          >
            {loading ? (
              <MoonLoader size={12} color="#d4a857" />
            ) : cartItem.qty === 1 ? (
              <DeleteIcon />
            ) : (
              "−"
            )}
          </button>
          <span className="gpcart-step-val">{cartItem.qty}</span>
          <button
            type="button"
            className="gpcart-step-btn"
            onClick={handleIncrementQuantity}
            disabled={loading}
            aria-label="Increase"
          >
            {loading ? <MoonLoader size={12} color="#d4a857" /> : "+"}
          </button>
        </div>
      </div>

      <div className="gpcart-row-subtotal">
        <span className="gpcart-row-label">Subtotal</span>
        <span className="gpcart-row-subval">{currencyPrefix}{lineTotal}</span>
      </div>

      <button
        type="button"
        onClick={handleRemove}
        className="gpcart-row-remove"
        disabled={loading}
        aria-label="Remove from cart"
        title="Remove from cart"
      >
        <DeleteIcon />
      </button>
    </div>
  );
};

export default CartProductRow;
